export const rupiah = (price) => {
  return 'Rp ' + (+price).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
};

export const parsePrice = (price) => {
  return 'Rp ' + (+price).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
};
